import React from 'react';

import Typography from 'components/Typography';
import { NumberRangeFormatter } from 'intl';

import { IDescriptionCurrency } from './interfaces';

export const DescriptionCurrencyRange: React.FC<IDescriptionCurrency> = ({
  value,
  maximumFractionDigits = 2,
  currency,
  ...other
}) => {
  return (
    <Typography {...other}>
      <NumberRangeFormatter.Currency
        value={value}
        maximumFractionDigits={maximumFractionDigits}
        currency={currency}
      />
    </Typography>
  );
};
